export default "__VITE_ASSET__NmIYiXWs__"